module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "set"
    }
  }, [_c('md-card', [((_vm.set.figures && _vm.set.figures[0].youtube) || _vm.set.thumbnail) ? _c('md-card-media', {
    key: "setThumbnail"
  }, [_c('img', {
    attrs: {
      "src": _vm.set.figures[0].youtube ? _vm.getThumbnail(_vm.set.figures[0].youtube.url) : _vm.getThumbnail(_vm.set.thumbnail),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.set.needsSet) ? _c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.setName) + " Set")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v(_vm._s(_vm.set.jpCaption) + "・セット")])]) : _c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.setName))]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v(_vm._s(_vm.set.jpCaption))])]), _vm._v(" "), (_vm.set.county) ? _c('div', {
    key: "setCounty",
    staticClass: "county"
  }, [_vm._l((_vm.set.county), function(county) {
    return _c('img', {
      attrs: {
        "src": _vm.getAvatar(county),
        "width": "40"
      }
    })
  }), _vm._v(" "), _c('br'), _vm._v("\n        County " + _vm._s(_vm.getCounty(_vm.set.county)) + "\n      ")], 2) : _vm._e(), _vm._v(" "), (_vm.set.editer) ? _c('p', [_vm._v("Created By " + _vm._s(_vm.set.editer))]) : _vm._e(), _vm._v(" "), (_vm.set.notices) ? _c('p', {
    key: "setNotices",
    staticClass: "notices"
  }, [_vm._v("\n        " + _vm._s(_vm.set.notices)), _c('br')]) : _vm._e(), _vm._v(" "), _c('md-subheader', [_vm._v("すべてのフィガー")]), _vm._v(" "), _c('md-list', {
    attrs: {
      "id": "setInfo"
    }
  }, [_vm._l((_vm.set.figures), function(figure, index) {
    return _c('md-list-item', {
      key: index,
      staticClass: "md-double-line"
    }, [_c('div', {
      staticClass: "md-list-text-container"
    }, [_c('span', [_c('a', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ('#figure' + index),
        expression: "'#figure' + index"
      }],
      attrs: {
        "href": '/#/set/' + _vm.setName + '/#'
      }
    }, [_vm._v("\n                Figure " + _vm._s(figure.order) + ": " + _vm._s(figure.summary) + "\n              ")])]), _vm._v(" "), ((_vm.set.hasLeadIn === undefined) || (figure.order === 1)) ? _c('p', {
      staticClass: "bars-info",
      on: {
        "click": function($event) {
          _vm.getBarsInfo('barsdialog', figure)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.getBars(figure)) + " bars + 8 bars lead in\n            ")]) : _c('p', [_vm._v("\n              " + _vm._s(_vm.getBars(figure)) + " bars\n            ")])]), _vm._v(" "), _c('md-chip', {
      staticClass: "md-primary"
    }, [_vm._v("\n            " + _vm._s(figure.rythmn) + "\n          ")]), _vm._v(" "), _c('md-divider')], 1)
  }), _vm._v(" "), (!_vm.isOriginalSet) ? _c('router-link', {
    staticClass: "md-raised md-primary",
    attrs: {
      "tag": "md-button",
      "to": {
        name: 'Figures',
        params: {
          setName: _vm.setName
        }
      },
      "id": "showFigures"
    }
  }, [_vm._v("\n          すべてのフィガーをみる\n        ")]) : _vm._e()], 2), _vm._v(" "), _c('md-card-content', {
    attrs: {
      "id": "figure"
    }
  }, _vm._l((_vm.set.figures), function(figure, figureIndex) {
    return _c('md-card', {
      key: figure.order,
      attrs: {
        "id": 'figure' + figureIndex
      }
    }, [_c('md-card-header', [_c('div', {
      staticClass: "md-title"
    }, [_vm._v("Figure " + _vm._s(figure.order) + ": " + _vm._s(figure.summary) + " "), _c('md-chip', {
      staticClass: "md-primary"
    }, [_vm._v(_vm._s(figure.rythmn))])], 1), _vm._v(" "), _c('div', {
      staticClass: "md-subhead bars-info",
      on: {
        "click": function($event) {
          _vm.getBarsInfo('barsdialog', figure)
        }
      }
    }, [_vm._v(_vm._s(_vm.getBars(figure)) + " bars + 8 bar lead in")])]), _vm._v(" "), (figure.description || figure.youtube) ? _c('md-card-content', {
      key: "figureMovieContainer"
    }, [(figure.youtube) ? _c('youtube', {
      key: "figureMovie",
      staticClass: "youtube",
      attrs: {
        "video-id": _vm.getYouTubeId(figure.youtube.url),
        "player-height": "auto",
        "player-width": "auto",
        "player-vars": {
          start: figure.youtube.start
        }
      }
    }) : _vm._e(), _vm._v("\n\n            " + _vm._s(figure.description) + "\n          ")], 1) : _vm._e(), _vm._v(" "), _c('md-list', _vm._l((figure.movements), function(movement, index) {
      return (movement.bar !== '') ? _c('md-list-item', {
        key: index,
        staticClass: "movement",
        class: movement.type,
        on: {
          "click": function($event) {
            _vm.openMovementCaption('captiondialog', figureIndex, movement.summary, movement.caption, movement.image)
          }
        }
      }, [(movement.type === 'call-repeat') ? _c('span', {
        key: "callRepeatPart",
        staticClass: "bar",
        class: movement.type
      }, [_c('md-chip', {
        staticClass: "md-primary"
      }, [_vm._v(_vm._s(movement.bar))])], 1) : (movement.type === 'repeat') ? _c('span', {
        key: "repeatPart",
        staticClass: "bar",
        class: movement.type
      }, [_c('md-chip', {
        staticClass: "md-primary"
      }, [_vm._v(_vm._s(movement.bar))])], 1) : (movement.type === 'nested-repeat') ? _c('span', {
        key: "nestedRepeatPart",
        staticClass: "bar",
        class: movement.type
      }, [_c('md-chip', {
        staticClass: "md-accent"
      }, [_vm._v(_vm._s(movement.bar))])], 1) : (movement.type === 'call-nested-repeat') ? _c('span', {
        key: "callNestedRepeatPart",
        staticClass: "bar",
        class: movement.type
      }, [_c('md-chip', {
        staticClass: "md-accent"
      }, [_vm._v(_vm._s(movement.bar))])], 1) : _c('span', {
        key: "noramlPart",
        staticClass: "bar",
        class: movement.type
      }, [_c('md-chip', {
        staticClass: "md-default"
      }, [_vm._v(_vm._s(movement.bar))])], 1), _vm._v(" "), _c('div', {
        staticClass: "md-list-text-container"
      }, [(!movement.caption) ? _c('span', {
        key: "movementWithoutCaption",
        staticClass: "summary"
      }, [_vm._v("\n                  " + _vm._s(movement.summary) + "\n                ")]) : _c('span', {
        key: "movementWithCaption"
      }, [_c('md-button', {
        staticClass: "summary",
        on: {
          "click": function($event) {
            _vm.openMovementCaption('captiondialog', figureIndex, movement.summary, movement.caption, movement.image)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(movement.summary)), _c('i', {
        staticClass: "material-icons"
      }, [_vm._v("launch")]), _c('div', {
        staticClass: "clear"
      })])], 1), _vm._v(" "), (movement.subject) ? _c('span', {
        key: "movementWithSubject"
      }, [_vm._v("\n                  " + _vm._s(movement.subject) + "\n                ")]) : _vm._e()]), _vm._v(" "), (index !== figure.movements.length - 1) ? _c('md-divider') : _vm._e()], 1) : _vm._e()
    }))], 1)
  })), _vm._v(" "), _c('md-divider'), _vm._v(" "), _c('md-card-content', [(_vm.set.referenceSite && _vm.set.referenceSite.danceminder) ? _c('md-button', {
    key: "danceminder",
    staticClass: "md-raised md-primary launchButton",
    attrs: {
      "href": _vm.set.referenceSite.danceminder,
      "target": "_blank"
    }
  }, [_vm._v("DanceMinder "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("launch")])]) : _vm._e(), _vm._v(" "), (_vm.set.referenceSite && _vm.set.referenceSite.irishSetDancing) ? _c('md-button', {
    key: "setdancingnews",
    staticClass: "md-raised md-primary launchButton",
    attrs: {
      "href": _vm.set.referenceSite.irishSetDancing,
      "target": "_blank"
    }
  }, [_vm._v("Set Dancing News "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("launch")])]) : _vm._e(), _vm._v(" "), (_vm.set.referenceSite && _vm.set.referenceSite.crookedriver) ? _c('md-button', {
    key: "crookedriver",
    staticClass: "md-raised md-primary launchButton",
    attrs: {
      "href": _vm.set.referenceSite.crookedriver,
      "target": "_blank"
    }
  }, [_vm._v("Crooked River "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("launch")])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "discharge"
  }, [_vm._v("\n          SetDancePal に記載されている内容は \"Toss The Feathers\", DanceMinder, Set Dancing News、CCÉ Japan、\n          YouTube、日本のケーリーなどで城が踊った経験をもとに書かれています。"), _c('br'), _vm._v("\n          誤字脱字、誤りなどありましたらお手数ですが以下のボタンからご報告ください。\n        ")]), _vm._v(" "), (_vm.isOriginalSet) ? _c('router-link', {
    staticClass: "md-raised md-primary",
    attrs: {
      "tag": "md-button",
      "to": {
        name: 'EditSet',
        params: {
          setName: _vm.setName
        }
      }
    }
  }, [_vm._v("\n          セットを編集する\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isOriginalSet) ? _c('router-link', {
    staticClass: "md-raised",
    attrs: {
      "tag": "md-button",
      "to": {
        name: 'Report',
        params: {
          setName: _vm.setName
        }
      }
    }
  }, [_vm._v("\n          誤字脱字を報告する\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-speed-dial', {
    staticClass: "md-fab-bottom-right",
    attrs: {
      "md-mode": "scale",
      "id": "view-setting"
    }
  }, [_c('md-button', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#set'),
      expression: "'#set'"
    }],
    staticClass: "md-fab",
    attrs: {
      "href": '/#/set/' + _vm.setName + '/#',
      "md-fab-trigger": ""
    }
  }, [_c('md-icon', [_vm._v("arrow_upward")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "barsdialog",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    },
    on: {
      "open": _vm.onOpen,
      "close": _vm.onClose
    }
  }, [_c('md-dialog-title', [_vm._v("\n        " + _vm._s(_vm.barsInfo.title) + "\n      ")]), _vm._v(" "), _c('md-dialog-content', [_c('ul', [_c('li', [_vm._v(_vm._s(_vm.barsInfo.rythmn))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.barsInfo.bars))])]), _vm._v("\n        　" + _vm._s(_vm.barsInfo.contentHtml) + "\n        ")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.closeDialog('barsdialog')
      }
    }
  }, [_vm._v(_vm._s(_vm.barsInfo.close))])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "captiondialog",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    },
    on: {
      "open": _vm.onOpen,
      "close": _vm.onClose
    }
  }, [_c('md-dialog-title', [(_vm.alert.image) ? _c('img', {
    key: "animation",
    staticClass: "animation",
    attrs: {
      "src": '/static/img/movement/' + _vm.alert.image
    }
  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.alert.title) + "\n      ")]), _vm._v(" "), _c('md-dialog-content', [_c('ul', [(!Array.isArray(_vm.alert.contentHtml)) ? _c('li', {
    key: "one_sentence"
  }, [_vm._v(_vm._s(_vm.alert.contentHtml))]) : _vm._l((_vm.alert.contentHtml), function(instruction, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(instruction))])
  })], 2)]), _vm._v(" "), _c('md-dialog-actions', [_c('router-link', {
    attrs: {
      "tag": "md-button",
      "to": {
        name: 'ReportMovement',
        params: {
          setName: _vm.setName,
          figureNumber: _vm.alert.figureNumber,
          movement: _vm.alert.title
        }
      }
    }
  }, [_vm._v("\n          誤字脱字を報告する\n        ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.closeDialog('captiondialog')
      }
    }
  }, [_vm._v(_vm._s(_vm.alert.close))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-715d1cb2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Set.vue
// module id = 336
// module chunks = 1